<template>
  <div>
    <v-avatar :size="size">
      <img v-show="localPreview" :src="localPreview" alt="img-container">
      <v-btn id="btn" flat fab large absolute @click="openFileChooser" :class="localPreview ? '' : 'btn-empty'">
        <v-icon v-show="!localPreview" size="25px">account_circle</v-icon>
      </v-btn>
      <input v-show="false" ref="file_input" type="file" accept="image/*" @change="onFileSelected"/>
    </v-avatar>

    <cropper-dialog
      v-model="cropper.show"
      :aspect-ratio="1"
      :src="cropper.src"
      @return="onFileCropped"
      @close="reset"/>

  </div>
</template>
<script>
import ImageInput from './ImageInput'

export default {
    extends: ImageInput,
    props: {
        size: {
            type: [Number, String],
            default: 48
        }
    }
}
</script>
<style lang="scss" scoped>
  #btn {
    height: 100%;
    width: 100%;
    color: white;
  }

  .btn-empty {
    background-color: rgba(0, 0, 0, 0.4) !important;
  }
</style>
